import React, { useEffect, useState, useRef } from 'react';
export function Solution() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      });
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  return <div ref={sectionRef} className="py-32 md:py-40 bg-white dark:bg-charcoal-900" data-id="element-267">
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center" data-id="element-268">
        <div className={`transition-all duration-1000 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-269">
          <h2 className="text-4xl md:text-5xl font-bold mb-8 text-charcoal-500 dark:text-white" data-id="element-270">
            Caltalk kills the guesswork
          </h2>
          <p className="text-xl md:text-2xl text-charcoal-400 dark:text-charcoal-300 leading-relaxed max-w-3xl mx-auto" data-id="element-271">
            Text what you're craving. Get macro-perfect matches nearby. Actually
            enjoy eating out.
          </p>
        </div>
      </div>
    </div>;
}